export default __webpack_public_path__ + "85895a2ffa167009859f7eb7485f664a.png";